export function getReportHeaders(accountId) {
    if (!Boolean(accountId))
        return;
    return new Headers({ "accountid": accountId });
}
